/** The console route that accepts an org-unit invitation, by its token. */
export const ACCEPT_INVITATION_ROUTE = "/invitations/:token/accept";

/** The link an invitee opens to reach that route on this console. */
export function acceptInvitationUrl(
  token: string,
  origin: string = window.location.origin
): string {
  return `${origin}${ACCEPT_INVITATION_ROUTE.replace(":token", encodeURIComponent(token))}`;
}
